<template>
    <div class="page_content connection_list_container" aria-label="connection list Page Content">

		<div class="module_section">
			<div id="connectionPopover" class="connection-popover questPopover"></div>
			<template v-if="connections.length > 0">
				<div class="container-fluid list_container">

					<template v-for="(connection, index) in connections">
						<div class="row data_row">

							<div class="title col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
								<!--
								<div class="thumbnail-section">
									<div class="icon icon-user" style="color: #918d1c; font-size: 66px;"></div>
								</div>
								-->
								<div class="col_title" style="cursor: default !important; color: #5f5f5f !important;">
									{{connection.firstName}} {{connection.lastName}}
								</div>
								<div class="small-desc" style="width: 50%;">
									{{connection.organization}}
								</div>
								<!--
								<b-popover :target="'connection_' + index"  container="connectionPopover"  triggers="hover focus" placement="topright">
                            		<div class="cont-sec">{{connection.firstName}} {{connection.lastName}}</div>
                            	</b-popover>
                            	-->
							</div>

							<div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 connection_col date_col">
								<div class="inner_container">

									<!--
									<div class="row">
										<div class="meeting_row col-12" :class="[connection.meetingDate ? '' : 'without-date']">
											<span style="float: left; margin-left: 0px; cursor: pointer;" class="icon2 ico-notes" aria-label="edit notes"  @click="openNoteModal(connection)"></span>
											<span style="float: left; margin-left: 15px; font-size: 22px; margin-top: 14px;">Notes</span>
										</div>
									</div>
									-->

									<div class="status_row meeting_row col-12" :class="[connection.meetingDate ? '' : 'without-date']">
											<span class="icon">
												<span class="ico-dateRange"></span>
											</span>
											<span class="txt_container">
												<span class="value" v-if="connection.meetingDate">
	                                                {{ changeMillisToDate(connection.meetingDate) }}
	                                            </span>
	                                            <span class="no_value" v-else>
	                                                <span class="input-datetime">
	                                                    <datetime
	                                                        :format="{year: 'numeric', month: '2-digit', day: '2-digit'}" auto
	                                                        type="date" v-model="meetingDate" :min-datetime="minDatetime" :week-start="7"
	                                                        @close="updateMeetingDateTime(connection)" placeholder="XX/XX/XXXX">
	                                                    </datetime>
	                                                </span>
	                                            </span>
											</span>
										</div>

								</div>
							</div>

							<div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 connection_col conversation_col">
								<template v-if="connection.meetingDate">
									<b-link :to="{ name: 'questLearn', params: {uuid: connection.conversationCourseId, entityType: 'LearningContent', entityUuid: connection.conversationQuestId, careerIdeaId: connection.careerIdeaId} }">
										<span class="status_row status_not_started" v-if="connection.conversationStatus === 0">
											<span class="icon">
												<span class="ico-conversation"></span>
											</span>
											<span class="txt_container">Conversation</span>
										</span>
										<span class="status_row status_in_progress" v-if="connection.conversationStatus === 1">
											<span class="icon">
											<span class="ico-conversation"></span>
										</span>
											<span class="txt_container">Conversation</span>
										</span>
										<span class="status_row status_done" v-if="connection.conversationStatus === 2">
											<span class="icon">
												<span class="ico-conversation"></span>
											</span>
											<span class="txt_container">Conversation</span>
										</span>
									</b-link>
								</template>
								<template v-else>
                                    <span class="status_row status_not_started" v-if="connection.conversationStatus === 0">
                                    	<span class="icon">
											<span class="ico-conversation"></span>
										</span>
										<span class="txt_container">Conversation</span>
                                    </span>
                                    <span class="status_row status_in_progress" v-if="connection.conversationStatus === 1">
                                    	<span class="icon">
											<span class="ico-conversation"></span>
										</span>
										<span class="txt_container">Conversation</span>
                                    </span>
                                    <span class="status_row status_done" v-if="connection.conversationStatus === 2">
                                    	<span class="icon">
											<span class="ico-conversation"></span>
										</span>
										<span class="txt_container">Conversation</span>
                                    </span>
								</template>
							</div>

							<div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 connection_col conversation_col">
								<span v-if="connection.conversationStatus === 2">
									<b-link :to="{ name: 'questLearn', params: {uuid: connection.conversationCourseId, entityType: 'LearningContent', entityUuid: connection.ratingQuestId, careerIdeaId: connection.careerIdeaId}, query: {isRatingQuest: true} }">
										<span class="status_row status_not_started" v-if="connection.ratingStatus === 0">
											<span class="icon">
												<span class="ico-score"></span>
											</span>
											<span class="txt_container">Feedback</span>
										</span>
										<span class="status_row status_in_progress" v-if="connection.ratingStatus === 1">
											<span class="icon">
												<span class="ico-score"></span>
											</span>
											<span class="txt_container">Feedback</span>
										</span>
										<span class="status_row status_done" v-if="connection.ratingStatus === 2">
											<span class="icon">
												<span class="ico-score"></span>
											</span>
											<span class="txt_container">Feedback</span>
										</span>
									</b-link>
								</span>
								<span v-else>
									<span class="status_row status_not_started">
										<span class="icon">
											<span class="ico-score"></span>
										</span>
										<span class="txt_container">Feedback</span>
									</span>
								</span>
							</div>


							<div class="fifth-col col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12" style="float: right;">
								<span class="action-link ico-edit mr-2" @click="editConnection(connection.uuid)" aria-label="edit" tabindex="0"></span>
								<span class="action-link icon-bin2" @click="showDeleteConnectionConfirmBox(connection.uuid, connection.firstName)" aria-label="delete" tabindex="0"></span>
							</div>

							<div class="row">
								<div class="step_row step_row2 col-12">
									<span class="label">Next Step:</span>
									<span class="result-col" v-if="connection.conversationStatus === 2 && connection.ratingStatus === 2">Done</span>
									<span class="result-col" v-if="connection.conversationStatus === 2 && connection.ratingStatus === 1">Scoring to be done</span>
									<span class="result-col" v-if="connection.conversationStatus === 2 && connection.ratingStatus === 0">Not Scored Yet</span>
									<span class="result-col" v-if="connection.conversationStatus === 1">Conversation Prep to be done</span>
									<span class="result-col" v-if="connection.conversationStatus === 0">Scheduled</span>
								</div>
							</div>

						</div> <!-- .data_row -->



					</template>

				</div> <!-- .list_container -->
			</template>

			<template v-else>
				<div class="no_data_msg">
					<span>0 Connections</span>
				</div>
				<div class="mt-3 text-center">
                    <span>Identify someone in your network who has knowledge of one of your career ideas. If you cannot think of some one right now, you can wait.</span>
                </div>
			</template>

			<b-modal ref="noteModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc class="note-popup" title="Notes" size="lg">
                <div slot="modal-header" class="header-section">
                    <div class="float-left">
                        <span class="icon2 ico-notes" style="font-size: 35px; float: left; margin-right: 10px;"></span>
                        <span>Notes</span>
                    </div>
                    <div class="float-right">
                        <button type="button" class="btn_close" @click="closeNotePopup">
                          <span class="ic-close"></span>
                        </button>
                    </div>
                </div>
                <div class="feedback-form">
                    <editor api-key="no-api-key" v-model="note" :init="{plugins: plugins, toolbar: toolbar,
                            base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
                    }" id="noteBodyEditor"></editor>
                </div>
                <div slot="modal-footer" class="submit-btn">
                    <b-button v-on:click="saveNote" class="btn button-primary next float-right" :disabled="!dirty" aria-label="ok"> ok </b-button>
                </div>
            </b-modal>

		</div>
		  <div class="modal_container modal_alart confirm">
            <b-modal class="delete-folder-popup" ref="popupModal" :title="'Please Confirm!'" :header-bg-variant="'folder-delete-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div>
                    <span>{{ deleteMessage }}</span>
                </div>
              <div slot="modal-header" class="header-section">
                <div class="ic ic-hd"></div>
                <div class="head_txt">Please Confirm!</div>
                <button type="button" class="btn_close" @click="closeConfirmBox" aria-label="close">
                  <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="deleteConnectionAndCloseConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                  <b-button @click="closeConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
              </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  import Editor from '@tinymce/tinymce-vue'

  export default {
    name: 'connection-list',
    props: ['careerIdeaId'],
    components: {
      Editor,
      Datetime
    },
    data () {
      return {
        note: '',
        dbNote: '',
        dirty: false,
        connections: [],
        meetingDate: null,
        selectedConnection: null,
        minDatetime: DateTime.utc().toISO(),
        deleteMessage: '',
        connectionIdToBeDeleted: '',
        connectionTitleToBeDeleted: ''
      }
    },

    mounted () {
      this.populateConnections()
    },

    watch: {
      note (newVal) {
        this.dirty = (newVal !== this.dbNote)
      }
    },

    methods: {
      ...mapActions([
        'loadConnections',
        'deleteConnectionDetail',
        'createConnection',
        'addConnectionNote'
      ]),

      populateConnections () {
        this.loadConnections(this.careerIdeaId).then(res => {
          this.connections = res
        })
      },

      editConnection (uuid) {
        return this.$router.push({name: 'connectionEdit', params: {careerIdeaId: this.careerIdeaId, connectionId: uuid}})
      },

      showDeleteConnectionConfirmBox (connectionUuid, connectionTitle) {
        this.connectionIdToBeDeleted = connectionUuid
        this.connectionTitleToBeDeleted = connectionTitle
        this.$refs.popupModal.show()
        this.deleteMessage = 'Are you sure you want to delete "' + connectionTitle + '" connection?'
      },

      deleteConnectionAndCloseConfirmBox () {
        this.$refs.popupModal.hide()
        this.deleteConnection()
      },

      deleteConnection () {
        if (this.connectionIdToBeDeleted) {
          this.deleteConnectionDetail(this.connectionIdToBeDeleted).then(res => {
            if (res && res.status === 204) {
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: 'Connection "' + this.connectionTitleToBeDeleted + '" is deleted successfully.'
              })
              this.populateConnections()
            }
          })
        }
      },

      closeConfirmBox () {
        this.connectionIdToBeDeleted = ''
        this.connectionTitleToBeDeleted = ''
        this.$refs.popupModal.hide()
      },

      changeDateToMillis (selected) {
        if (selected) {
          return DateTime.fromISO(selected).toMillis()
        }
        return null
      },

      changeMillisToDate (selected) {
        if (selected) {
          return DateTime.fromMillis(selected).toFormat('MM/dd/yyyy')
        }
        return null
      },

      updateMeetingDateTime (connection) {
        if (this.meetingDate) {
          let meetingDateTime = this.changeDateToMillis(this.meetingDate)
          connection.meetingDate = meetingDateTime
          this.createConnection(connection).then(res => {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'You have successfully scheduled a meeting on ' + this.changeMillisToDate(meetingDateTime) + ' with "' + connection.firstName + ' ' + connection.lastName + '".'
            })
          })
        }
        this.meetingDate = null
      },

      openNoteModal (connection) {
        this.selectedConnection = connection
        if (connection.note) {
          this.note = connection.note
          this.dbNote = connection.note
        }
        this.$refs.noteModal.show()
      },

      closeNotePopup () {
        this.note = ''
        this.dbNote = ''
        this.dirty = false
        this.$refs.noteModal.hide()
        this.selectedConnection = null
      },

      saveNote () {
        let data = {
          note: this.note,
          connectionId: this.selectedConnection.uuid
        }
        this.addConnectionNote(data).then(res => {
          if (res) {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Note saved successfully for your connection "' + this.selectedConnection.firstName + ' ' + this.selectedConnection.lastName + '".'
            })
            this.closeNotePopup()
            this.populateConnections()
          }
        })
      },

      navigateToConversationQuest (courseId, learningContentId) {
        return this.$router.push({ name: 'entityDetail', params: {uuid: courseId, entityType: 'LearningContent', entityUuid: learningContentId} })
      }
    }
  }
</script>

<style scoped>
    .text-center {
        line-height: 100px;
        text-align: center;
        vertical-align: middle;
    }

</style>



// WEBPACK FOOTER //
// src/app/quest/components/ConnectionList.vue